<template>
  <span>
    <div
      class="kbx-progress-bar"
      klickbox-edit-item="progress-bar-done"
      klickbox-edit-item-dad="progress"
      :klickbox-edit-label="$t('edit.canvas.past_item')"
      :style="getStyle()"
      style="width: 50%;"></div>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    getStyle() {
      const styles = this.stepStyle('progress-bar-done');
      return { background: styles.backgroundColor };
    },
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Done.vue?2a75866e
 **/